// src/app/core/services/call.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CallSession, StartCallPayload } from '../models/call';
import { baseURL } from '../constants/base.url';

interface ApiResponse<T> {
  status: number;
  message?: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class CallService {

  constructor(private http: HttpClient) { }

  startCall(payload: StartCallPayload): Observable<CallSession> {
    return this.http
      .post<ApiResponse<{ session: CallSession }>>(`${baseURL}calls`, payload)
      .pipe(map(res => res.data.session));
  }

  getCallById(callId: string): Observable<CallSession> {
    return this.http
      .get<ApiResponse<{ session: CallSession }>>(`${baseURL}calls/${callId}`)
      .pipe(map(res => res.data.session));
  }

  endCall(callId: string, reason?: string): Observable<CallSession> {
    return this.http
      .post<ApiResponse<{ session: CallSession }>>(`${baseURL}calls/${callId}/end`, { reason })
      .pipe(map(res => res.data.session));
  }

  listCalls(query: { page?: number; limit?: number; status?: string; type?: string; threadId?: string } = {}): Observable<any> {
    let params = new HttpParams();
    Object.keys(query).forEach((k: any) => {
      const v = (query as any)[k];
      if (v !== undefined && v !== null && String(v).trim() !== '') {
        params = params.set(k, String(v));
      }
    });

    return this.http
      .get<ApiResponse<any>>(`${baseURL}calls`, { params })
      .pipe(map(res => res.data));
  }
}